module.exports = __webpack_public_path__ + "static/media/order-tracking-icon.fcd53336.svg";